/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  DropdownButton,
  MenuItem,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { kFilterTypes } from '../../constants';

const propTypes = {
  onSelect: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
};

const NewFilterButton = (props) => {
  const { onSelect } = props;
  const intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.dptrend.filters');

  return (
    <DropdownButton
      id="group-by"
      bsStyle="aisz-new-cond"
      title={(
        <span>
          <i className="fa fa-plus-circle" aria-hidden="true" />{' '}
          {intlMsg.msg('new')}
        </span>
      )}
      onSelect={onSelect}
      pullRight
    >
      {kFilterTypes.map(type => (
        <MenuItem key={type} eventKey={type}>
          <i className="fa fa-plus-circle" aria-hidden="true" />{' '}
          {intlMsg.msg(type)}
        </MenuItem>
      ))}
    </DropdownButton>
  );
};

NewFilterButton.propTypes = propTypes;

export default injectIntl(NewFilterButton);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DataPointsView/coms/DataPointTrend/coms/NewFilterButton/index.jsx